var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('adopted',{staticClass:"mb-6"}),_c('waiting-adoption',{ref:"workersWaitingAdoption",staticClass:"mt-6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }